<!--
 * @Description:
 * @Version: 2.0
 * @Autor: daikeyi
 * @Date: 2020-06-05 15:25:04
 * @LastEditors: daikeyi
 * @LastEditTime: 2021-01-20 11:25:33
-->
<template>
    <div class="op-submit-bar">
        <div class="info">
            <span class="num">共{{num}}件,</span>
            <span>合计金额</span>
            <span class="price">¥{{price.toFixed(2)}}</span>
        </div>
        <van-button round @click="submit" class="submit-btn" type="primary" v-show="btnShow">{{buttonText}}</van-button>
    </div>
</template>

<script>
export default {
    props: {
        'button-text': {
            default: '立即购买'
        },
        num: {
            type: Number,
            default: 0
        },
        price: {
            type: Number,
            default: 0
        },
        btnShow: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {

        };
    },
    methods: {
        submit() {
            this.$emit('submit');
        }
    }
};
</script>

<style lang="scss">
    .op-submit-bar {
        font-size: 14px;
        height: 50px;
        color: $text-color;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .info {
            span {
                vertical-align: middle;
            }
            .num {
                font-size: 12px;
            }
            .price {
                color: $primary-color;
            }
        }
        .submit-btn {
            width: 120px;
            margin-left: 14px;
            &.van-button {
                height: 40px;
                line-height: 38px;
            }
        }
    }

</style>
